<mat-card class="filter settingHeader">
  <div class="name">
    Manage Quick Web Forms
  </div>
  <div class="quickAction">
    <mat-form-field appearance="fill">
      <mat-label>Select</mat-label>
      <mat-select (selectionChange)="OnChange3C($event)" value="1">
        <mat-option value="1">{{CoreShowName}}</mat-option>
        <mat-option value="2">{{ContactShowName}}</mat-option> 
        <mat-option value="3">{{CompanyShowName}}</mat-option>          
      </mat-select>
    </mat-form-field>   

    <div class="">         
      <button mat-flat-button color="primary" (click)="selectForm(forms)"> Add Form </button>
   </div>

  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <!-- <span class="fieldName">Icon</span> -->
      <span class="fieldName">Alias Name</span>
      <span class="fieldName">Form Name</span>
      <span class="category">Folder Name</span>     
      <!-- <span class="category">Icon</span> -->
      <span class="requried">Active/Inactive</span>
      <span class="editField">Edit</span>
      <span class="delete">Delete</span>
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)">
    <div class="example-box fieldRow" *ngFor="let task of FormReportfolderList" cdkDrag>
      <span class="moveicon"></span>
      <div class="DragIcon" cdkDragHandle>
        <mat-icon>drag_indicator</mat-icon>
      </div>
      
      <span class="fieldName">   
        <mat-icon>{{task.formIcon}}</mat-icon> &nbsp;
        {{task.formAlias}}      
      </span> 
       
      <span class="fieldName">      
        {{task.formName}}
      </span>  
      <span class="category">{{task.folderName}}</span>  
      <!-- <span class="category">{{task.folderName}}</span>      -->
      
      <!-- <span class="category"><mat-icon>{{task.formIcon}}</mat-icon></span>      -->
      <span class="requried">
        <mat-slide-toggle color="primary" [checked]="task.isActive" (change)="UpdateStatusToggle(task,$event)">
        </mat-slide-toggle>
      </span> 

      <span class="editField">
        <button mat-icon-button class="editbtn" (click)="UpdateTaskDialog(myUpdateDialog,task)">
          <mat-icon>edit</mat-icon>
        </button>
      </span>

      <ng-container>            
          <span class="delete">
          <button mat-icon-button class="trash" (click)="deleteFolderForm(task)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </ng-container>

    </div>
  
    </div>

         
  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</div>




<ng-template #forms>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>note_add</mat-icon>
    </span>
    My Forms
    <button mat-icon-button (click)="closeForms()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>


    <div class="myforms">
      <div class="drive mainLink">
        <div class="folderName" (click)="GetAllForms()">
          <mat-icon class="type">account_balance</mat-icon>
          Forms
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
            matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>
       

      </div>

      <div class="driveDetail" >

        <div class="breadcumb">
          <span (click)="breadCrumbMainClick()">Forms</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <div class="d-flex">
          <mat-card class="files w-49 mr-15">
            <table class="mat-table">
              <thead>
                <tr class="mat-header-row">
                  <th class="mat-header-cell wstar">&nbsp; </th>
                  <!-- <th class="mat-header-cell wstar"></th> -->
                  <th class="mat-header-cell wstar"></th>
                  <th class="mat-header-cell">Name</th>               
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let form of FormFolderListMiddleSection; let i = index;">
                  <tr class="mat-row foldericon" (click)="radioChange(form,'MyForm')">
                    <td class="mat-cell wstar">
                      <span class="checkbo" *ngIf="form.type == 2">
                        <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                          (change)="radioChange(form,'MyForm')"></mat-radio-button>
                      </span>
                    </td>                 
  
                    <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false">
                      <mat-icon>folder</mat-icon>
                    </td>
  
                    <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true">
                      <mat-icon>folder_shared</mat-icon>
                    </td>
                  
                    <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==3">
                      <img src="../../../../assets/images/icons/form_html.svg" alt="" width="28" />                   
                    </td>
  
                    <td class="mat-cell" *ngIf="form.type == 1">
                      <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                    </td>
  
                    <td class="mat-cell" *ngIf="form.type == 2">
                      <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                    </td>                 
  
                  </tr>
                </ng-container>
  
                <ng-container *ngIf="!FormFolderListMiddleSection">
                  <tr>
                    <td colspan="7">
                      <p class="nocontent">No Items Found</p>
                    </td>
                  </tr>
                </ng-container>
  
              </tbody>
            </table>
          </mat-card>
  
         <ng-container *ngIf="selectButtonShow==true"> 
          <mat-card class="w-49" >
            <mat-form-field class="example-full-width">
              <mat-label>Alias Name</mat-label>
              <input matInput [required]="true" [(ngModel)]="formAlias" maxlength="8" placeholder="Add alias name"/>          
            </mat-form-field>
  
            <button *ngIf="formIcon==''" mat-flat-button color="primary" (click)="selectIcon()">
               Select Icon 
              </button>
  
              <div *ngIf="formIcon!=''"> 
                <button mat-icon-button ><mat-icon>{{formIcon}}</mat-icon></button>            
              </div>
  
            <mat-form-field appearance="fill">
              <mat-label>Select Folder</mat-label>
              <mat-select (selectionChange)="selectFolder($event)" required>
                <mat-option *ngFor="let stat of FormfolderList" [value]="stat.folderID">
                    {{ stat.folderName }}
                </mat-option>
            </mat-select>
              
            </mat-form-field>  
  
          </mat-card>
        </ng-container>
        </div>

      </div>

     

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button color="basic" (click)="closeForms()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!selectButtonShow" (click)="SelectFormSubmit()">Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #myUpdateDialog> 
  <h2 mat-dialog-title>
      Update Alias/Icon
      <button mat-icon-button (click)="closeUpdate()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  
 
  <mat-form-field class="example-full-width">
    <mat-label>Alias Name</mat-label>
    <input matInput [required]="true" [(ngModel)]="formAlias" maxlength="8" placeholder="Add alias name"/>          
  </mat-form-field>
   
   <div *ngIf="formIcon!=''"> 
     <mat-icon>{{formIcon}}</mat-icon>          
   </div>

   <button mat-flat-button color="primary" (click)="selectIcon()">
    Select Icon 
   </button>

  

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="closeUpdate()">Cancel</button>
  <button mat-flat-button color="primary" 
  (click)="updateFormFolder()">
  Update
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>

</ng-template>


<app-loader></app-loader>